import { Component, EventEmitter, Input, Output } from '@angular/core'
import { isImportedFromABBV2 } from '@tokeet-frontend/inquiry'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import * as R from 'ramda'

@Component({
  selector: 'app-inquiry-action-list',
  templateUrl: './inquiry-action-list.component.html',
  host: { class: 'dropdown-menu dropdown-menu-right' },
  styleUrls: ['./inquiry-action-list.component.scss'],
})
export class InquiryActionListComponent {
  @Output() link = new EventEmitter()
  @Output() archive = new EventEmitter()
  @Output() unarchive = new EventEmitter()
  @Output() followup = new EventEmitter()
  @Output() nofollowup = new EventEmitter()
  @Output() read = new EventEmitter()
  @Output() unread = new EventEmitter()
  @Output() tags = new EventEmitter()
  @Output() columns = new EventEmitter()
  @Output() delete = new EventEmitter()
  @Output() paid = new EventEmitter()
  @Output() unpaid = new EventEmitter()
  @Output() import = new EventEmitter()

  @Input('selection')
  set selectedInquiries(inquiries: Inquiry[]) {
    this.isAnyUnRead = R.any((i: Inquiry) => !i.read, inquiries) || R.isEmpty(inquiries)
    this.isAnyUnArchived = R.any((i: Inquiry) => !i.archived, inquiries) || R.isEmpty(inquiries)
    this.isAnyNoFollow = R.any((i: Inquiry) => !i.followup, inquiries) || R.isEmpty(inquiries)
    this.isAnyUnpaid = R.any((i: Inquiry) => !i.paid, inquiries) || R.isEmpty(inquiries)
    this.isAnyImportedFromABBV2 = R.any((i: Inquiry) => isImportedFromABBV2(i), inquiries)
  }

  isAnyUnRead = false
  isAnyUnArchived = false
  isAnyNoFollow = false
  isAnyUnpaid = false
  isAnyImportedFromABBV2 = false

  hasColumns = this.columns.observers.length > 0
}
